module.exports = __webpack_public_path__ + "static/media/ca_6.22e62e16.png";